import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreviews from './components/ArticlePreviews';
import SEOContent from './components/SEOContent';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';
import { SITE_URL } from '@/constants/site';

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Sugargoo Spreadsheet Hub",
  "url": SITE_URL,
  "description": "Discover the ultimate Sugargoo Spreadsheet 2026. Find updated product spreadsheets, Sugargoo reviews, shipping costs, coupons, warehouse guides, and expert shopping tips.",
  "inLanguage": "en",
  "publisher": {
    "@type": "Organization",
    "name": "Sugargoo Spreadsheet Hub",
    "url": SITE_URL
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": SITE_URL + "/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <main>
      <JsonLd data={websiteJsonLd} />
      <Navbar />
      <Hero />
      <CategoryGrid />
      <ArticlePreviews />
      <SEOContent />
      <Footer />
    </main>
  );
}